import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitoashtavinayakcab() {



  const cardData = {
    keyword: " Mumbai to Ashtavinayak Cab Service",

"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Ashtavinayak cab services, ensuring a smooth, safe, and spiritually fulfilling journey for devotees and families. The Ashtavinayak Yatra covers eight sacred temples of Lord Ganesha located across Maharashtra, making it one of the most important pilgrimage tours. Whether you are planning a one-day darshan or a multi-day spiritual trip, our professional drivers and well-maintained vehicles ensure a hassle-free travel experience. The Mumbai to Ashtavinayak route varies depending on temple selection and typically covers multiple districts of Maharashtra with flexible itinerary planning. We offer customizable packages including one-way trips, round trips, and complete Ashtavinayak Yatra tours with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for individuals, families, and group pilgrimages. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Ashtavinayak travel.",

"topPlaces": [
  {
    "title": "Moreshwar Temple (Morgaon)",
    "description": "Moreshwar Temple in Morgaon is considered the starting and most important temple of the Ashtavinayak Yatra. Dedicated to Lord Ganesha, it is a highly sacred pilgrimage site with beautiful traditional architecture and deep spiritual significance."
  },
  {
    "title": "Siddhivinayak Temple (Siddhatek)",
    "description": "Siddhivinayak Temple in Siddhatek is known as a powerful Ganpati temple where devotees seek blessings for success and removal of obstacles. It is located on the banks of the Bhima River in a peaceful rural setting."
  },
  {
    "title": "Ballaleshwar Temple (Pali)",
    "description": "Ballaleshwar Temple in Pali is unique as it is the only Ashtavinayak temple named after a devotee of Lord Ganesha. Surrounded by mountains, it offers a calm and spiritual atmosphere."
  },
  {
    "title": "Varadvinayak Temple (Mahad)",
    "description": "Varadvinayak Temple in Mahad is known for granting wishes of devotees. It is surrounded by greenery and has a serene environment ideal for peaceful darshan."
  },
  {
    "title": "Chintamani Temple (Theur)",
    "description": "Chintamani Temple in Theur is a famous Ashtavinayak temple believed to remove worries and bring mental peace. It is located near Pune and holds strong spiritual importance."
  },
  {
    "title": "Girijatmaj Temple (Lenyadri)",
    "description": "Girijatmaj Temple in Lenyadri is unique as it is carved inside ancient Buddhist caves on a hill. Devotees need to climb steps to reach the temple, making it both spiritual and adventurous."
  },
  {
    "title": "Vighnahar Temple (Ozar)",
    "description": "Vighnahar Temple in Ozar is dedicated to Lord Ganesha as the remover of obstacles. It is beautifully built and attracts devotees seeking success and prosperity."
  },
  {
    "title": "Mahaganapati Temple (Ranjangaon)",
    "description": "Mahaganapati Temple in Ranjangaon is known for its powerful idol of Lord Ganesha. It is believed that Lord Shiva worshipped Ganesha here before fighting demons."
  },

],







services: [
  {
    name: "Mumbai to Ashtavinayak Cab",
    description: "Mumbai to Ashtavinayak cab service offers a comfortable and well-planned journey to the eight sacred Ganpati temples across Maharashtra. This spiritual tour is ideal for families, devotees, and group travelers seeking a peaceful darshan experience. Professional drivers familiar with temple routes ensure smooth navigation. Vehicles are well-maintained for long-distance travel. Flexible pickup options across Mumbai add convenience. It ensures a safe and fulfilling pilgrimage journey."
  },
  {
    name: "Mumbai to Ashtavinayak Taxi",
    description: "Mumbai to Ashtavinayak taxi provides convenient and reliable transport for devotees visiting all eight temples. Door-to-door pickup and drop ensure a hassle-free experience. Vehicles are clean and driven by experienced chauffeurs. This service is suitable for family trips and religious tours. Flexible travel schedules add comfort. It ensures a smooth and peaceful journey."
  },
  {
    name: "Mumbai to Ashtavinayak Cab Service",
    description: "Mumbai to Ashtavinayak cab service is designed for long-distance pilgrimage travel with a focus on comfort and safety. The route covers multiple temples across different locations, requiring experienced drivers. Vehicles are maintained for long journeys. Customers can choose sedan, SUV, or luxury vehicles. It ensures a reliable and organized darshan trip."
  },
  {
    name: "Mumbai to Ashtavinayak Taxi Service",
    description: "Mumbai to Ashtavinayak taxi service offers dependable travel solutions for devotees planning a temple tour. This service ensures safe travel across highways and rural roads. Professional drivers and well-maintained vehicles enhance comfort. Flexible scheduling allows proper darshan planning. It guarantees a stress-free journey."
  },
  {
    name: "Cab from Mumbai to Ashtavinayak",
    description: "Cab from Mumbai to Ashtavinayak provides a personalized and private travel experience for temple visits. Travelers can enjoy flexible stops and customized routes. This service is ideal for families and small groups. Professional drivers ensure safe travel across all temple locations. It offers a relaxed and devotional journey."
  },
  {
    name: "Taxi from Mumbai to Ashtavinayak",
    description: "Taxi from Mumbai to Ashtavinayak offers a convenient and efficient way to complete the sacred temple circuit. With experienced drivers and comfortable vehicles, this service ensures a smooth journey. Door-to-door pickup adds convenience. Suitable for short and multi-day trips. It ensures a reliable travel experience."
  },
  {
    name: "Mumbai to Ashtavinayak Cab Booking",
    description: "Mumbai to Ashtavinayak cab booking allows travelers to reserve their pilgrimage ride easily. Customers can choose vehicle type, pickup location, and travel duration. Instant confirmation and transparent pricing make the process simple. It ensures a hassle-free booking experience."
  },
  {
    name: "Mumbai to Ashtavinayak Taxi Booking Online",
    description: "Mumbai to Ashtavinayak taxi booking online provides a quick and easy way to book your temple tour. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak pilgrimage seasons."
  },
  {
    name: "Mumbai to Ashtavinayak Cab Price",
    description: "Mumbai to Ashtavinayak cab price varies depending on vehicle type, trip duration, and package selection. Transparent pricing ensures no hidden charges. Budget-friendly and premium options are available. It helps travelers plan their pilgrimage efficiently."
  },
  {
    name: "Mumbai to Ashtavinayak Taxi Fare",
    description: "Mumbai to Ashtavinayak taxi fare is designed to be affordable and competitive for multi-destination travel. Fare depends on vehicle type and number of days required. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Ashtavinayak One Way Cab",
    description: "Mumbai to Ashtavinayak one way cab is suitable for travelers planning partial routes or specific temple visits. This service offers flexibility in travel planning. Comfortable vehicles and experienced drivers ensure smooth journeys. It is ideal for customized travel plans."
  },
  {
    name: "Mumbai to Ashtavinayak Round Trip Taxi",
    description: "Mumbai to Ashtavinayak round trip taxi is ideal for completing the full temple circuit with return travel included. This package covers all eight temples with flexible scheduling. Suitable for family and group travel. Professional drivers ensure timely darshan visits. It ensures convenience and efficiency."
  },
  {
    name: "Mumbai to Ashtavinayak Innova Cab",
    description: "Mumbai to Ashtavinayak Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space for multi-day trips. Ideal for long-distance temple tours. Professional drivers ensure safe travel. It provides a premium experience."
  },
  {
    name: "Mumbai to Ashtavinayak Ertiga Cab",
    description: "Mumbai to Ashtavinayak Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. Ideal for budget-friendly pilgrimage travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Ashtavinayak Sedan Cab",
    description: "Mumbai to Ashtavinayak sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for long journeys. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Ashtavinayak SUV Taxi",
    description: "Mumbai to Ashtavinayak SUV taxi provides extra space and comfort for group travel. SUVs perform well on highways and rural roads. This option is ideal for families and large groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Ashtavinayak Darshan Cab from Mumbai",
    description: "Ashtavinayak darshan cab from Mumbai offers a complete pilgrimage solution covering all eight Ganpati temples. This service includes route planning, comfortable vehicles, and experienced drivers. Ideal for devotees seeking a peaceful and organized trip. It ensures a spiritually fulfilling journey."
  },
  {
    name: "Best Ashtavinayak Cab Package Mumbai",
    description: "Best Ashtavinayak cab package Mumbai provides a well-planned and comfortable travel experience for devotees. Packages include multi-day trips, flexible schedules, and comfortable vehicles. Professional drivers ensure smooth temple visits. Transparent pricing and easy booking enhance convenience. It guarantees a premium pilgrimage experience."
  }
],

tableData: [
  ["Mumbai to Ashtavinayak Cab", "Mumbai to Ashtavinayak Taxi"],
  ["Mumbai to Ashtavinayak Cab Service", "Mumbai to Ashtavinayak Taxi Service"],
  ["Cab from Mumbai to Ashtavinayak", "Taxi from Mumbai to Ashtavinayak"],
  ["Mumbai to Ashtavinayak Cab Booking", "Mumbai to Ashtavinayak Taxi Booking Online"],
  ["Mumbai to Ashtavinayak Cab Price", "Mumbai to Ashtavinayak Taxi Fare"],
  ["Mumbai to Ashtavinayak One Way Cab", "Mumbai to Ashtavinayak Round Trip Taxi"],
  ["Mumbai to Ashtavinayak Innova Cab", "Mumbai to Ashtavinayak Ertiga Cab"],
  ["Mumbai to Ashtavinayak Sedan Cab", "Mumbai to Ashtavinayak SUV Taxi"],
  ["Ashtavinayak Darshan Cab from Mumbai", "Best Ashtavinayak Cab Package Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Complete Ashtavinayak Darshan Tour",
    WhyChoosedescription: "Royal Route Cabs offers a well-planned Mumbai to Ashtavinayak cab service covering all 8 Ganpati temples with comfortable and organized travel."
  },
  {
    WhyChooseheading: "Experienced Pilgrimage Drivers",
    WhyChoosedescription: "Our drivers are experienced with Ashtavinayak routes and temple sequences, ensuring smooth navigation and timely darshan at all locations."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs without any hidden fees."
  },
  {
    WhyChooseheading: "Flexible Multi-Day Tour Packages",
    WhyChoosedescription: "We offer customizable 2-day and 3-day Ashtavinayak tour packages from Mumbai based on your travel plan and comfort."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly sanitized to ensure a comfortable spiritual journey."
  },
  {
    WhyChooseheading: "24/7 Pickup & Travel Flexibility",
    WhyChoosedescription: "Our cab service is available 24/7, allowing flexible departure times from Mumbai for your Ashtavinayak yatra."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options for Groups",
    WhyChoosedescription: "We provide sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group pilgrimages."
  },
  {
    WhyChooseheading: "Trusted Religious Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Mumbai to Ashtavinayak cab service due to reliable drivers, planned routes, and comfortable journeys."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Ashtavinayak cab service?", answer: "Yes, Royal Route Cabs offers complete Ashtavinayak cab tour packages from Mumbai." },
  { question: "How many days are required for Ashtavinayak darshan?", answer: "Usually 2 to 3 days are required to complete all 8 temples comfortably." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Ashtavinayak cab service operates 24/7." },
  { question: "Which vehicles are available for this tour?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize the tour plan?", answer: "Yes, we provide fully customizable Ashtavinayak tour packages based on your travel preferences." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during festive seasons and weekends." },
  { question: "Do you provide driver assistance for temple sequence?", answer: "Yes, our drivers guide you with proper temple sequence for smooth darshan." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Milind Joshi",
    feedback: "The Mumbai to Ashtavinayak cab journey with Royal Route Cabs was very peaceful and well-managed. The driver handled the temple circuit smoothly and comfortably.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback: "Excellent Ashtavinayak darshan trip from Mumbai. The cab was clean, the ride was comfortable, and the entire pilgrimage felt well-organized and stress-free.",
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ashtavinayak Cab Service",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-ashtavinayak-cab.jpg", // replace if needed
  "description": "Book Mumbai to Ashtavinayak cab service with Royal Route Cabs for a comfortable spiritual journey. Cover all Ashtavinayak temples with one-way and round-trip options in sedan, SUV, Innova, and luxury cars. Safe, reliable, and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-ashtavinayak-cab-service"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Ashtavinayak Cab Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Ashtavinayak cab service with Royal Route Cabs. Complete Ashtavinayak darshan tour with sedan, SUV, Innova & luxury cars. Safe, comfortable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to ashtavinayak cab, mumbai to ashtavinayak taxi, mumbai to ashtavinayak cab service, mumbai to ashtavinayak taxi service, cab from mumbai to ashtavinayak, taxi from mumbai to ashtavinayak, mumbai to ashtavinayak cab booking, mumbai to ashtavinayak taxi booking online, mumbai to ashtavinayak cab price, mumbai to ashtavinayak taxi fare, mumbai to ashtavinayak one way cab, mumbai to ashtavinayak round trip taxi, mumbai to ashtavinayak innova cab, mumbai to ashtavinayak ertiga cab, mumbai to ashtavinayak sedan cab, mumbai to ashtavinayak suv taxi, ashtavinayak darshan cab from mumbai, best ashtavinayak cab package mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoashtavinayakcab;